var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('homePromo'),_c('homeNews'),_c('homeConstruction'),_c('homeAbout'),_c('homeVacancy'),_c('homeProjects')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }